<div class="activity-filters">
    <div class="filter-row-inline">
        <div class="app-c-form-group" *ngIf="!orgId">
            <label class="app-c-form--label">Organization</label>
            <select class="app-c-form-control" [(ngModel)]="organizationId">
                <option [value]="[]">All</option>
                <option *ngFor="let organization of organizations" [value]="organization.id">
                    {{ organization.name }}
                </option>
            </select>
        </div>

        <div class="app-c-form-group">
            <label class="app-c-form--label">Activity Type</label>
            <select class="app-c-form-control" [(ngModel)]="activityTypeId">
                <option [value]="[]">All</option>
                <option *ngFor="let activityType of activityTypes" [value]="activityType.typeId">
                    {{ activityType.message }}
                </option>
            </select>
        </div>

        <div class="app-c-form-group">
            <label class="app-c-form--label">From</label>
            <input class="app-c-form-control" type="date" [(ngModel)]="fromDate" />
        </div>

        <div class="app-c-form-group">
            <label class="app-c-form--label">To</label>
            <input class="app-c-form-control" type="date" [(ngModel)]="toDate" />
        </div>

        <div class="app-c-form-group filter-action">
            <button class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="onGenerate()">
                Build
            </button>
        </div>
    </div>
</div>

<div class="activity-table-wrap">
    <div class="text-center">
        <page-loader *ngIf="loadedNumberCount > loadedNumber"></page-loader>
    </div>
    <div class="table-responsive" *ngIf="!loading">
        <table class="user-table">
            <thead>
                <tr>
                    <th translate>activity.headers.0</th>
                    <th *ngIf="userListingEnable" translate>activity.headers.1</th>
                    <th *ngIf="orgListingEnable" translate>activity.headers.2</th>
                    <th style="width:14%;" translate>activity.headers.3</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of activeactivity">
                    <td>{{ row.message }}</td>
                    <td *ngIf="userListingEnable">{{ row.userName }}</td>
                    <td *ngIf="orgListingEnable">{{ row.organizationName }}</td>
                    <td>{{ row.created | date: 'MM/dd/yy' }}</td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="!activeactivity || activeactivity.length === 0" class="empty-state">
            No activity found.
        </p>
    </div>
    <div class="load-more-wrap" *ngIf="activeactivity?.length > 0">
        <button *ngIf="!loadMoreLoading"
            class="app-c-btn app-c-btn--secondary app-c-btn--curve"
            (click)="loadMore()">Load more</button>
        <span *ngIf="loadMoreLoading" class="loading-text">Loading...</span>
    </div>
</div>
